
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
// Import version for cache-busting
import packageJson from './package.json';
import { storage } from './services/storage';

// Helper to get browser language or fallback (synchronous fallback)
const getInitialLanguage = () => {
  // Try localStorage first for immediate sync access (web only)
  if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
    const saved = localStorage.getItem('deskbay_lang');
    if (saved) return saved;
  }

  const browserLang = navigator.language.split('-')[0].toLowerCase();
  const supported = ['it', 'en', 'es', 'fr', 'de'];
  return supported.includes(browserLang) ? browserLang : 'en';
};

// Async function to load saved language from cross-platform storage
export const loadSavedLanguage = async (): Promise<string | null> => {
  return await storage.get('deskbay_lang');
};

// Async function to save language preference
export const saveLanguagePreference = async (lang: string): Promise<void> => {
  await storage.set('deskbay_lang', lang);
  // Also update localStorage for immediate sync access on web
  if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
    localStorage.setItem('deskbay_lang', lang);
  }
};

i18next
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    debug: false,

    backend: {
      // Load translations with version for cache-busting
      // This ensures new deployments fetch fresh translations
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${packageJson.version}`,
    },

    interpolation: {
      escapeValue: false, // React already handles XSS
    },

    react: {
      useSuspense: true, // Enable suspense for async loading
    },
  });

// Load saved language from storage and update if different
loadSavedLanguage().then(savedLang => {
  if (savedLang && savedLang !== i18next.language) {
    i18next.changeLanguage(savedLang);
  }
});

export default i18next;
